module.exports = require("./ff-Latn-MR.d.ts");